import React from 'react';
import DataTable from 'components/data-table';
import { RowItemListGroupTypeReception } from 'modules/reception/datatable/add';
import { header } from "constants/table";

class ListGroupTypeReception extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    }
  }

  addItem() {
    let arrLength = this.state.data.length;
    if (arrLength == 0 || (arrLength > 0 && this.state.data[arrLength - 1].hoVaTen != '')) {
      this.state.data[this.state.data.length] = {
        hoVaTen: '',
        cmndHoChieu: '',
        diaChi: '',
        soDienThoai: '',
        doanDiCungId: ''
      };
      this.setState({
        data: this.state.data
      });
    }
  }

  componentDidMount() {
    if (this.props.data.donCuId || this.props.data.donId && this.props.data.listDoanDiCung) {
      this.state.data = this.props.data.listDoanDiCung;
      this.setState({...this.state});
    }
    this.addItem();
  }

  onChange(index, data) {
    this.state.data[index] = data;
    this.setState({
      data: this.state.data
    });
    this.props.onChange(this.state.data);
  }

  handleRemove(index) {
    let Array = this.state.data;
    this.props.onRemove('DOAN_DI_CUNG', Array[index]);
    Array.splice(index, 1);
    this.props.data.doanDongNguoi = Array;
    this.setState({
      data: Array
    });
  }

  render() {
    let data = [];
    this.state.data.map((item, i) => {
      item.type = 'doanDongNguoi';
      data.push(item);
    });
    return (
      <div>
        <div className="title">
          <div className="rows">
            <div className="col-6">
              <h3>Danh sách đoàn đi cùng</h3>
            </div>
          </div>
        </div>
        <div className="items-form  inline-bottom">
          <div className="rows">
            <div className="col-12 row-center">
              <DataTable header={ header.addReception.groupMember } dataList={ data } hidePagination={ true } parent={ this }>
                <RowItemListGroupTypeReception/>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListGroupTypeReception;



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/ListGroupTypeReception.jsx